
riot.tag2('permission-rights-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#settings/permissions"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{item.name || \'Редактирование прав\'}</div>\n    <div class="row">\n      <div class="col-md-12">\n        <datatable rows="{item.permissions}" cols="{cols}" handlers="{handlers}">\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="">\n            <input type="checkbox" onclick="{stopPropagation}" onchange="{handlers.toggleAll}" __checked="{row.mask == 15}">\n          </datatable-cell>\n          <datatable-cell name="">\n            <input type="checkbox" onclick="{stopPropagation}" onchange="{handlers.toggle}" __checked="{handlers.calc(row.mask, 8)}" data-value="8">\n          </datatable-cell>\n          <datatable-cell name="">\n            <input type="checkbox" onclick="{stopPropagation}" onchange="{handlers.toggle}" __checked="{handlers.calc(row.mask, 4)}" data-value="4">\n          </datatable-cell>\n          <datatable-cell name="">\n            <input type="checkbox" onclick="{stopPropagation}" onchange="{handlers.toggle}" __checked="{handlers.calc(row.mask, 2)}" data-value="2">\n          </datatable-cell>\n          <datatable-cell name="">\n            <input type="checkbox" onclick="{stopPropagation}" onchange="{handlers.toggle}" __checked="{handlers.calc(row.mask, 1)}" data-value="1">\n          </datatable-cell>\n        </datatable>\n      </div>\n    </div>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var self = this;

self.item = {};

self.cols = [{ name: 'name', value: 'Объект' }, { name: '', value: 'Полный доступ', classes: 'text-center' }, { name: '', value: 'Чтение', classes: 'text-center' }, { name: '', value: 'Добавление', classes: 'text-center' }, { name: '', value: 'Редактирование', classes: 'text-center' }, { name: '', value: 'Удаление', classes: 'text-center' }];

self.submit = function () {
    self.loader = true;

    API.request({
        object: 'PermissionRole',
        method: 'Save',
        data: self.item,
        success: function success(response) {
            self.item = response;
            popups.create({ title: 'Успех!', text: 'Права сохранены!', style: 'popup-success' });
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
};

self.reload = function () {
    if (self.item && self.item.id) observable.trigger('permissions-edit', self.item.id);
};

self.handlers = {
    calc: function calc(value, k) {
        return parseInt(value || 0) & k;
    },
    toggleAll: function toggleAll(e) {
        var checked = e.target.checked;
        e.item.row.mask = checked ? 15 : 0;
    },
    toggle: function toggle(e) {
        var checked = e.target.checked;
        var k = parseInt(e.target.getAttribute('data-value'));
        e.item.row.mask = parseInt(e.item.row.mask || 0) + (checked ? k : -k);
    }
};

observable.on('permissions-edit', function (id) {
    self.item = {};
    self.loader = true;
    self.update();

    API.request({
        object: 'PermissionRole',
        method: 'Info',
        data: { id: id },
        success: function success(response) {
            self.item = response;
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
});
});


// WEBPACK FOOTER //
// ./pages/settings/permissions/permission-rights-edit.tag